import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Padding extends Vue {
	@Prop() padding!: string
}
